import RegisterPage from 'views/Pages/RegisterPage';
import LoginPage from 'views/Pages/LoginPage';
import LockScreenPage from 'views/Pages/LockScreenPage';
import ChangePasswordPage from 'views/Pages/ChangePasswordPage';
import Alerts from 'views/Alerts/Alerts';
import Users from 'views/Users/Users';
import Organizations from 'views/Organizations/Organizations';
import UserProfilePage from 'views/Pages/UserProfilePage';

// @material-ui/icons
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';

import permissionsMap from 'utils/permissions/permissionsMap';
import layoutNames from 'utils/enums/layout-names.enum';
import EditOrganization from 'views/Organizations/EditOrganization';

const dashRoutes = [
	{
		path: '/register',
		component: RegisterPage,
		layout: `/${layoutNames.auth}`,
	},
	{
		path: '/login',
		component: LoginPage,
		layout: `/${layoutNames.auth}`,
	},
	{
		path: '/change-password',
		component: ChangePasswordPage,
		layout: `/${layoutNames.auth}`,
	},
	{
		path: '/lock',
		component: LockScreenPage,
		layout: `/${layoutNames.auth}`,
	},
	{
		path: '/profile',
		component: UserProfilePage,
		layout: `/${layoutNames.portal}`,
	},
	{
		path: '/alerts',
		name: 'Alerts',
		component: Alerts,
		layout: `/${layoutNames.portal}`,
		isMenuItem: false,
		views: [
			{
				path: '',
				name: 'Alerts',
				component: Alerts,
				layout: `/${layoutNames.portal}`,
			},
		],
	},
	{
		path: '/organizations',
		name: 'Organizations',
		icon: BusinessOutlinedIcon,
		component: Organizations,
		layout: `/${layoutNames.portal}`,
		isMenuItem: true,
		views: [
			{
				path: '',
				name: 'Organizations',
				component: Organizations,
				layout: `/${layoutNames.portal}`,
			},
			{
				path: '/details/:id',
				name: 'Organization Details',
				component: EditOrganization,
				layout: `/${layoutNames.portal}`,
			},
			{
				path: '/create',
				name: 'Create Organization',
				component: EditOrganization,
				layout: `/${layoutNames.portal}`,
			},
		],
	},
	{
		path: '/users',
		name: 'Users',
		icon: PeopleOutlineIcon,
		component: Users,
		layout: `/${layoutNames.portal}`,
		isMenuItem: true,
		allowedFor: permissionsMap.adminPanel.items.userManagement.read,
		views: [
			{
				path: '',
				name: 'Users',
				component: Users,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.adminPanel.items.userManagement.read,
			},
		],
	},
];

export default dashRoutes;
